// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form_customFormStyle__jJmnY input, .form_customFormStyle__jJmnY textarea, .form_customFormStyle__jJmnY label {
  background-color: var(--background-color1);
  border: 0;
  color: var(--text-color0) !important;
  font-size: 1.1rem;
  border-radius: 0.4rem;
  padding: 1rem;
  font-family: var(--Raleway);
  width: 100%;
}

.form_customFormStyle__jJmnY label {
  color: var(--text-color2) !important;
}

.form_customFormStyle__jJmnY input[type="submit"] {
  background-color: var(--accent-color0) !important;
  color: #e6e6e6 !important;
  font-weight: 600;
  /* width: max-content; */
  width: 100%;
  padding: 1rem 3rem;
  align-self: flex-end;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.form_customFormStyle__jJmnY input::placeholder {
  left: 0rem;
  transition: all 500ms cubic-bezier(0.67, 0.01, 0.34, 0.99);
}

.form_customFormStyle__jJmnY input:focus::placeholder {
  color: rgba(0, 0, 0, 0);
  left: -2rem;
  position: relative;
}


/* inverted bg theme */
.form_invertedBgTheme__L0zry input, .form_invertedBgTheme__L0zry textarea, .form_invertedBgTheme__L0zry label {
  background-color: var(--background-color0) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/SpecificStyles/form.module.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;EAC1C,SAAS;EACT,oCAAoC;EACpC,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;EACb,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iDAAiD;EACjD,yBAAyB;EACzB,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,0DAA0D;AAC5D;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;;AAGA,sBAAsB;AACtB;EACE,qDAAqD;AACvD","sourcesContent":[".customFormStyle input, .customFormStyle textarea, .customFormStyle label {\n  background-color: var(--background-color1);\n  border: 0;\n  color: var(--text-color0) !important;\n  font-size: 1.1rem;\n  border-radius: 0.4rem;\n  padding: 1rem;\n  font-family: var(--Raleway);\n  width: 100%;\n}\n\n.customFormStyle label {\n  color: var(--text-color2) !important;\n}\n\n.customFormStyle input[type=\"submit\"] {\n  background-color: var(--accent-color0) !important;\n  color: #e6e6e6 !important;\n  font-weight: 600;\n  /* width: max-content; */\n  width: 100%;\n  padding: 1rem 3rem;\n  align-self: flex-end;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n}\n\n.customFormStyle input::placeholder {\n  left: 0rem;\n  transition: all 500ms cubic-bezier(0.67, 0.01, 0.34, 0.99);\n}\n\n.customFormStyle input:focus::placeholder {\n  color: rgba(0, 0, 0, 0);\n  left: -2rem;\n  position: relative;\n}\n\n\n/* inverted bg theme */\n.invertedBgTheme input, .invertedBgTheme textarea, .invertedBgTheme label {\n  background-color: var(--background-color0) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customFormStyle": `form_customFormStyle__jJmnY`,
	"invertedBgTheme": `form_invertedBgTheme__L0zry`
};
export default ___CSS_LOADER_EXPORT___;
